import { takeLatest, put, call, fork } from 'redux-saga/effects';
import DashboardTypes from './dashboard.types';
import {
	getDashboardData,
	getDashboardEmployeeListEnhanced,
	getCheckedInCardEmployeeList,
	getActiveEmployeesCardEmployeeList,
	getLateCheckInCardEmployeeList,
	getEarlyCheckOutCardEmployeeList,
	getOnLeaveCardEmployeeList,
	getAbsentCardEmployeeList,
	getActiveEmployeesCard,
	getCheckedInCard,
	getLateCheckInCard,
	getEarlyCheckOutCard,
	getOnLeaveCard,
	getAbsentCard,
} from './dashboard.service';
import {
	dashboardSuccess,
	dashboardFailure,
	employeeListEnhancedSuccess,
	employeeListEnhancedFailure,
	getCheckedInCardEmployeeListSuccess,
	getCheckedInCardEmployeeListFailure,
	getActiveEmployeesCardEmployeeListSuccess,
	getActiveEmployeesCardEmployeeListFailure,
	getLateCheckInCardEmployeeListSuccess,
	getLateCheckInCardEmployeeListFailure,
	getEarlyCheckOutCardEmployeeListSuccess,
	getEarlyCheckOutCardEmployeeListFailure,
	getOnLeaveCardEmployeeListSuccess,
	getOnLeaveCardEmployeeListFailure,
	getAbsentCardEmployeeListSuccess,
	getAbsentCardEmployeeListFailure,
	getActiveEmployeesCardSuccess,
	getActiveEmployeesCardFailure,
	getCheckedInCardSuccess,
	getCheckedInCardFailure,
	getLateCheckInCardSuccess,
	getLateCheckInCardFailure,
	getEarlyCheckOutCardSuccess,
	getEarlyCheckOutCardFailure,
	getOnLeaveCardSuccess,
	getOnLeaveCardFailure,
	getAbsentCardSuccess,
	getAbsentCardFailure,
} from './dashboard.action';
import AlertManager from '../../utils/alertManager';
import { encryptData } from '../_common/enode-decode';

export function* fetchSectionWiseDataSaga(payload: any) {
	try {
		const key = 'fetchSectionWiseDataKey';
		const DashboardAttendance =
			payload.payload.branchID === 'all' || payload.payload.branchID === ''
				? 'DashboardAttendanceDetailsforAll'
				: 'DashboardAttendanceDetails';
		const encryptedData = encryptData(payload.payload, key);
		// @ts-ignore
		const responseData = yield call(
			getDashboardData as any,
			encryptedData,
			DashboardAttendance,
		);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'error') {
				if (process.env.NODE_ENV === 'development') console.log('Received failure response');
				yield put(dashboardFailure(responseData.data));
			} else {
				if (process.env.NODE_ENV === 'development') console.log('Received success response');
				yield put(dashboardSuccess(responseData.data));
			}
		}
	} catch (error: any) {
		if (process.env.NODE_ENV === 'development') console.error('Error in fetchSectionWiseData:', error);
		yield put(dashboardFailure(error?.response?.data?.message || 'An error occurred'));
	}
}

export function* onDashboardStart(): Generator<any, void, any> {
	yield takeLatest(DashboardTypes.DASHBOARD_START as any, fetchSectionWiseDataSaga);
}

// Enhanced Employee List Saga
export function* fetchEmployeeListEnhancedSaga(payload: any) {
	try {
		const key = 'fetchEmployeeListEnhancedKey';
		if (process.env.NODE_ENV === 'development') console.log('fetchEmployeeListEnhancedSaga called with payload:', payload);
		const encryptedData = encryptData(payload.payload, key);
		if (process.env.NODE_ENV === 'development') console.log('fetchEmployeeListEnhancedSaga encryptedData:', encryptedData);
		// @ts-ignore
		const responseData = yield call(getDashboardEmployeeListEnhanced as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'error') {
				if (process.env.NODE_ENV === 'development') console.log('Received enhanced employee list failure response');
				yield put(employeeListEnhancedFailure(responseData.data));
			} else {
				if (process.env.NODE_ENV === 'development') console.log('Received enhanced employee list success response');
				yield put(employeeListEnhancedSuccess(responseData.data));
			}
		}
	} catch (error: any) {
		if (process.env.NODE_ENV === 'development') console.error('Error in fetchEmployeeListEnhanced:', error);
		yield put(
			employeeListEnhancedFailure(error?.response?.data?.message || 'An error occurred'),
		);
	}
}

export function* onEmployeeListEnhancedStart(): Generator<any, void, any> {
	yield takeLatest(
		DashboardTypes.EMPLOYEE_LIST_ENHANCED_START as any,
		fetchEmployeeListEnhancedSaga,
	);
}

// Dashboard Card Sagas
export function* fetchActiveEmployeesCardSaga(payload: any) {
	try {
		const key = DashboardTypes.GET_ACTIVE_EMPLOYEES_CARD_KEY;
		const encryptedData = encryptData(payload.payload, key);
		// @ts-ignore
		const responseData = yield call(getActiveEmployeesCard as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'error') {
				yield put(getActiveEmployeesCardFailure(responseData.data));
			} else {
				yield put(getActiveEmployeesCardSuccess(responseData.data));
			}
		}
	} catch (error: any) {
		if (process.env.NODE_ENV === 'development') console.error('Error in fetchActiveEmployeesCard:', error);
		yield put(getActiveEmployeesCardFailure(error?.response?.data?.message || 'An error occurred'));
	}
}

export function* onGetActiveEmployeesCardStart(): Generator<any, void, any> {
	yield takeLatest(DashboardTypes.GET_ACTIVE_EMPLOYEES_CARD_START as any, fetchActiveEmployeesCardSaga);
}

export function* fetchCheckedInCardSaga(payload: any) {
	try {
		const key = DashboardTypes.GET_CHECKED_IN_CARD_KEY;
		const encryptedData = encryptData(payload.payload, key);
		// @ts-ignore
		const responseData = yield call(getCheckedInCard as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'error') {
				yield put(getCheckedInCardFailure(responseData.data));
			} else {
				yield put(getCheckedInCardSuccess(responseData.data));
			}
		}
	} catch (error: any) {
		if (process.env.NODE_ENV === 'development') console.error('Error in fetchCheckedInCard:', error);
		yield put(getCheckedInCardFailure(error?.response?.data?.message || 'An error occurred'));
	}
}

export function* onGetCheckedInCardStart(): Generator<any, void, any> {
	yield takeLatest(DashboardTypes.GET_CHECKED_IN_CARD_START as any, fetchCheckedInCardSaga);
}

export function* fetchLateCheckInCardSaga(payload: any) {
	try {
		const key = DashboardTypes.GET_LATE_CHECK_IN_CARD_KEY;
		const encryptedData = encryptData(payload.payload, key);
		// @ts-ignore
		const responseData = yield call(getLateCheckInCard as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'error') {
				yield put(getLateCheckInCardFailure(responseData.data));
			} else {
				yield put(getLateCheckInCardSuccess(responseData.data));
			}
		}
	} catch (error: any) {
		if (process.env.NODE_ENV === 'development') console.error('Error in fetchLateCheckInCard:', error);
		yield put(getLateCheckInCardFailure(error?.response?.data?.message || 'An error occurred'));
	}
}

export function* onGetLateCheckInCardStart(): Generator<any, void, any> {
	yield takeLatest(DashboardTypes.GET_LATE_CHECK_IN_CARD_START as any, fetchLateCheckInCardSaga);
}

export function* fetchEarlyCheckOutCardSaga(payload: any) {
	try {
		const key = DashboardTypes.GET_EARLY_CHECK_OUT_CARD_KEY;
		const encryptedData = encryptData(payload.payload, key);
		// @ts-ignore
		const responseData = yield call(getEarlyCheckOutCard as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'error') {
				yield put(getEarlyCheckOutCardFailure(responseData.data));
			} else {
				yield put(getEarlyCheckOutCardSuccess(responseData.data));
			}
		}
	} catch (error: any) {
		if (process.env.NODE_ENV === 'development') console.error('Error in fetchEarlyCheckOutCard:', error);
		yield put(getEarlyCheckOutCardFailure(error?.response?.data?.message || 'An error occurred'));
	}
}

export function* onGetEarlyCheckOutCardStart(): Generator<any, void, any> {
	yield takeLatest(DashboardTypes.GET_EARLY_CHECK_OUT_CARD_START as any, fetchEarlyCheckOutCardSaga);
}

export function* fetchOnLeaveCardSaga(payload: any) {
	try {
		const key = DashboardTypes.GET_ON_LEAVE_CARD_KEY;
		const encryptedData = encryptData(payload.payload, key);
		// @ts-ignore
		const responseData = yield call(getOnLeaveCard as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'error') {
				yield put(getOnLeaveCardFailure(responseData.data));
			} else {
				yield put(getOnLeaveCardSuccess(responseData.data));
			}
		}
	} catch (error: any) {
		if (process.env.NODE_ENV === 'development') console.error('Error in fetchOnLeaveCard:', error);
		yield put(getOnLeaveCardFailure(error?.response?.data?.message || 'An error occurred'));
	}
}

export function* onGetOnLeaveCardStart(): Generator<any, void, any> {
	yield takeLatest(DashboardTypes.GET_ON_LEAVE_CARD_START as any, fetchOnLeaveCardSaga);
}

export function* fetchAbsentCardSaga(payload: any) {
	try {
		const key = DashboardTypes.GET_ABSENT_CARD_KEY;
		const encryptedData = encryptData(payload.payload, key);
		// @ts-ignore
		const responseData = yield call(getAbsentCard as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'error') {
				yield put(getAbsentCardFailure(responseData.data));
			} else {
				yield put(getAbsentCardSuccess(responseData.data));
			}
		}
	} catch (error: any) {
		if (process.env.NODE_ENV === 'development') console.error('Error in fetchAbsentCard:', error);
		yield put(getAbsentCardFailure(error?.response?.data?.message || 'An error occurred'));
	}
}

export function* onGetAbsentCardStart(): Generator<any, void, any> {
	yield takeLatest(DashboardTypes.GET_ABSENT_CARD_START as any, fetchAbsentCardSaga);
}

// Checked In Card Employee List Saga
export function* fetchCheckedInCardEmployeeListSaga(payload: any) {
	try {
		const key = 'GetCheckedInCardEmployeeListFromWeb';
		if (process.env.NODE_ENV === 'development') console.log('fetchCheckedInCardEmployeeListSaga called with payload:', payload);
		const encryptedData = encryptData(payload.payload, key);
		if (process.env.NODE_ENV === 'development') console.log('fetchCheckedInCardEmployeeListSaga encryptedData:', encryptedData);
		// @ts-ignore
		const responseData = yield call(getCheckedInCardEmployeeList as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'error') {
				if (process.env.NODE_ENV === 'development') console.log('Received checked in card employee list failure response');
				yield put(getCheckedInCardEmployeeListFailure(responseData.data));
			} else {
				if (process.env.NODE_ENV === 'development') console.log('Received checked in card employee list success response');
				yield put(getCheckedInCardEmployeeListSuccess(responseData.data));
			}
		}
	} catch (error: any) {
		if (process.env.NODE_ENV === 'development') console.error('Error in fetchCheckedInCardEmployeeList:', error);
		yield put(
			getCheckedInCardEmployeeListFailure(error?.response?.data?.message || 'An error occurred'),
		);
	}
}

export function* onGetCheckedInCardEmployeeListStart(): Generator<any, void, any> {
	yield takeLatest(
		DashboardTypes.GET_CHECKED_IN_CARD_EMPLOYEE_LIST_START as any,
		fetchCheckedInCardEmployeeListSaga,
	);
}

// Active Employees Card Employee List Saga
export function* fetchActiveEmployeesCardEmployeeListSaga(payload: any) {
	try {
		const key = 'GetActiveEmployeesCardEmployeeListFromWeb';
		const encryptedData = encryptData(payload.payload, key);
		// @ts-ignore
		const responseData = yield call(getActiveEmployeesCardEmployeeList as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'error') {
				yield put(getActiveEmployeesCardEmployeeListFailure(responseData.data));
			} else {
				yield put(getActiveEmployeesCardEmployeeListSuccess(responseData.data));
			}
		}
	} catch (error: any) {
		if (process.env.NODE_ENV === 'development') console.error('Error in fetchActiveEmployeesCardEmployeeList:', error);
		yield put(getActiveEmployeesCardEmployeeListFailure(error?.response?.data?.message || 'An error occurred'));
	}
}

export function* onGetActiveEmployeesCardEmployeeListStart(): Generator<any, void, any> {
	yield takeLatest(DashboardTypes.GET_ACTIVE_EMPLOYEES_CARD_EMPLOYEE_LIST_START as any, fetchActiveEmployeesCardEmployeeListSaga);
}

// Late Check In Card Employee List Saga
export function* fetchLateCheckInCardEmployeeListSaga(payload: any) {
	try {
		const key = 'GetLateCheckInCardEmployeeListFromWeb';
		const encryptedData = encryptData(payload.payload, key);
		// @ts-ignore
		const responseData = yield call(getLateCheckInCardEmployeeList as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'error') {
				yield put(getLateCheckInCardEmployeeListFailure(responseData.data));
			} else {
				yield put(getLateCheckInCardEmployeeListSuccess(responseData.data));
			}
		}
	} catch (error: any) {
		if (process.env.NODE_ENV === 'development') console.error('Error in fetchLateCheckInCardEmployeeList:', error);
		yield put(getLateCheckInCardEmployeeListFailure(error?.response?.data?.message || 'An error occurred'));
	}
}

export function* onGetLateCheckInCardEmployeeListStart(): Generator<any, void, any> {
	yield takeLatest(DashboardTypes.GET_LATE_CHECK_IN_CARD_EMPLOYEE_LIST_START as any, fetchLateCheckInCardEmployeeListSaga);
}

// Early Check Out Card Employee List Saga
export function* fetchEarlyCheckOutCardEmployeeListSaga(payload: any) {
	try {
		const key = 'GetEarlyCheckOutCardEmployeeListFromWeb';
		const encryptedData = encryptData(payload.payload, key);
		// @ts-ignore
		const responseData = yield call(getEarlyCheckOutCardEmployeeList as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'error') {
				yield put(getEarlyCheckOutCardEmployeeListFailure(responseData.data));
			} else {
				yield put(getEarlyCheckOutCardEmployeeListSuccess(responseData.data));
			}
		}
	} catch (error: any) {
		if (process.env.NODE_ENV === 'development') console.error('Error in fetchEarlyCheckOutCardEmployeeList:', error);
		yield put(getEarlyCheckOutCardEmployeeListFailure(error?.response?.data?.message || 'An error occurred'));
	}
}

export function* onGetEarlyCheckOutCardEmployeeListStart(): Generator<any, void, any> {
	yield takeLatest(DashboardTypes.GET_EARLY_CHECK_OUT_CARD_EMPLOYEE_LIST_START as any, fetchEarlyCheckOutCardEmployeeListSaga);
}

// On Leave Card Employee List Saga
export function* fetchOnLeaveCardEmployeeListSaga(payload: any) {
	try {
		const key = 'GetOnLeaveCardEmployeeListFromWeb';
		const encryptedData = encryptData(payload.payload, key);
		// @ts-ignore
		const responseData = yield call(getOnLeaveCardEmployeeList as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'error') {
				yield put(getOnLeaveCardEmployeeListFailure(responseData.data));
			} else {
				yield put(getOnLeaveCardEmployeeListSuccess(responseData.data));
			}
		}
	} catch (error: any) {
		if (process.env.NODE_ENV === 'development') console.error('Error in fetchOnLeaveCardEmployeeList:', error);
		yield put(getOnLeaveCardEmployeeListFailure(error?.response?.data?.message || 'An error occurred'));
	}
}

export function* onGetOnLeaveCardEmployeeListStart(): Generator<any, void, any> {
	yield takeLatest(DashboardTypes.GET_ON_LEAVE_CARD_EMPLOYEE_LIST_START as any, fetchOnLeaveCardEmployeeListSaga);
}

// Absent Card Employee List Saga
export function* fetchAbsentCardEmployeeListSaga(payload: any) {
	try {
		const key = 'GetAbsentCardEmployeeListFromWeb';
		const encryptedData = encryptData(payload.payload, key);
		// @ts-ignore
		const responseData = yield call(getAbsentCardEmployeeList as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'error') {
				yield put(getAbsentCardEmployeeListFailure(responseData.data));
			} else {
				yield put(getAbsentCardEmployeeListSuccess(responseData.data));
			}
		}
	} catch (error: any) {
		if (process.env.NODE_ENV === 'development') console.error('Error in fetchAbsentCardEmployeeList:', error);
		yield put(getAbsentCardEmployeeListFailure(error?.response?.data?.message || 'An error occurred'));
	}
}

export function* onGetAbsentCardEmployeeListStart(): Generator<any, void, any> {
	yield takeLatest(DashboardTypes.GET_ABSENT_CARD_EMPLOYEE_LIST_START as any, fetchAbsentCardEmployeeListSaga);
}

export function* dashboardSaga(): Generator<any, void, any> {
	if (process.env.NODE_ENV === 'development') console.log('Dashboard saga starting...');
	yield fork(onDashboardStart);
	yield fork(onEmployeeListEnhancedStart);
	yield fork(onGetCheckedInCardEmployeeListStart);
	yield fork(onGetActiveEmployeesCardEmployeeListStart);
	yield fork(onGetLateCheckInCardEmployeeListStart);
	yield fork(onGetEarlyCheckOutCardEmployeeListStart);
	yield fork(onGetOnLeaveCardEmployeeListStart);
	yield fork(onGetAbsentCardEmployeeListStart);
	yield fork(onGetActiveEmployeesCardStart);
	yield fork(onGetCheckedInCardStart);
	yield fork(onGetLateCheckInCardStart);
	yield fork(onGetEarlyCheckOutCardStart);
	yield fork(onGetOnLeaveCardStart);
	yield fork(onGetAbsentCardStart);
	if (process.env.NODE_ENV === 'development') console.log('Dashboard saga: All watchers forked');
}
